import { RelationNode } from './RelationNode';
export var RelationCore;
(function (RelationCore) {
    function project(core, projectionNode) {
        return {
            ...core,
            projections: [...(core.projections || []), projectionNode],
        };
    }
    RelationCore.project = project;
    function from(core, fromNode) {
        return { ...core, from: fromNode };
    }
    RelationCore.from = from;
    function join(core, joinNodes) {
        return { ...core, joins: [...(core.joins || []), ...joinNodes] };
    }
    RelationCore.join = join;
    function where(core, exprs) {
        const currWhere = core.where || RelationNode.where();
        return {
            ...core,
            where: { ...currWhere, exprs: [...currWhere.exprs, ...exprs] },
        };
    }
    RelationCore.where = where;
    function group(core, exprs) {
        const currGroup = core.group || RelationNode.group();
        return {
            ...core,
            group: { ...currGroup, exprs: [...currGroup.exprs, ...exprs] },
        };
    }
    RelationCore.group = group;
    function having(core, exprs) {
        const currHaving = core.having || RelationNode.having();
        return {
            ...core,
            having: { ...currHaving, exprs: [...currHaving.exprs, ...exprs] },
        };
    }
    RelationCore.having = having;
})(RelationCore || (RelationCore = {}));
